import { Link } from 'react-router-dom';
import { useState, useRef } from 'react';
// import { useSelector } from 'react-redux';
import { t } from '../../content';
import mazharLogo from "../../assets/images/logos/apex_analytics_green_logo.svg";
import { FormControl, TextField } from '@mui/material';
import B2BApiService from '../../B2bApiService';
import * as Constants from './../../constants'
import EmailIcon from "@mui/icons-material/Email";
import { Toast } from 'primereact/toast';
import Button from '../../components/reusableElementsComponents/Button';
import { InputAdornment } from '@mui/material';
import MobileAuthHeader from '../../components/layoutComponents/authComponents/MobileAuthHeader';
import DesktopAuthDecoration from '../../components/layoutComponents/authComponents/DesktopAuthDecoration';
import AuthPageChrome from '../../components/layoutComponents/authComponents/AuthPageChrome';
import { useLocale } from '../../locale';


function RecoverPassword() {
    const { withLocale, locale } = useLocale();
    let apiObject = new B2BApiService();
    const myToast = useRef(null);
    const showToast = (severityValue, summaryValue, detailValue) => {
        myToast.current.show({ severity: severityValue, summary: summaryValue, detail: detailValue });
    }
    const [email, setEmail] = useState('')
    const [error, setError] = useState(false)
    // const data = useSelector(state => state.contentfulData.all['Company recover password page']);

    const onSubmit = () => {
        if (email && !error) {
            apiObject.EmailConfirmation({ email: email, locale }).then(response => {
                if (response.httpStatus === 200) {
                    showToast('success', t('toasts.successMessage'), t('toasts.mailSent'))
                    setTimeout(() => {
                        window.location.href = withLocale('/login')
                    }, 2000)
                }
            })
        }
    }

    const handleBlur = () => {
        let valid = Constants.VALID_EMAIL.test(email)
        if (valid) {
            setError(false)
        }
        else {
            setError(true)
        }
    }

    return (
            <div className="row auth-page-wrapper p-0 m-0">
                <AuthPageChrome logoSrc={mazharLogo} />
                <MobileAuthHeader logo={true} secondaryTitle={t('auth.recover.titleMobile')} subTitle={t('auth.recover.subtitleMobile')} />
                <div className="col-12 col-lg-6 login-form">
                    <div className="d-none d-lg-block">
                        <h3 className="title semi-bold">{t('auth.recover.titleDesktop')}</h3>
                        <p className="grey s">{t('auth.recover.subtitleDesktop')}</p>
                    </div>
                    <Toast ref={myToast} />

                    <div className="section">
                        <FormControl style={{ width: "100%" }}>
                            <TextField
                                placeholder={t('common.placeholders.enterEmail')}
                                id="email"
                                name="email"
                                type="text"
                                autoComplete="on"
                                value={email}
                                onBlur={handleBlur}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <EmailIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                variant="standard"
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError(false);
                                }}
                            />
                        </FormControl>
                        {error &&
                            <div>
                                <p style={{ color: "red" }}>{t('validation.emailRequired')}</p>
                            </div>
                        }
                        <div className="authButtons" style={{ display: "flex", marginTop: "30px" }}>
                            <Button btnstyle={'mazhrBtn default-green white w-50'} type="submit" onClick={onSubmit} errord={error}>
                                <p className='m-0 light'>{t('auth.recover.sendLink')}</p>
                            </Button>
                            <Link className="mazhrBtn mazhrBtn light-green w-50" to={withLocale('/login')}>

                                <p className='m-0 light'>{t('auth.recover.backToLogin')}</p>
                            </Link>
                        </div>

                    </div>

                </div>
                <DesktopAuthDecoration />
            </div >
        )
}

export default RecoverPassword;
